import axios from 'axios';
//------------------------------↓api基础路径↓---------------------------------------//
export let apiUrl = "http://www.yuanwhite.com/clientapi/client"
// export let apiUrl = "http://localhost:8108/client"
// export let apiUrl = "http://yuanwhite.110pay.com/clientapi/client"
// export let apiUrl = "https://www.shidingcc.com/sdshopapi"

//------------------------------↓请求封装↓---------------------------------------//
//url为后缀路径，params为参数
//1、post请求
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(apiUrl + url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
//get请求
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(apiUrl + url, {
      params: params
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
//------------------------------拦截器↓↓↓---------------------------------------//
//官网好像不需要拦截器 ╰(●’◡’●)╮ ◔ ‸◔？ ╭(●｀∀´●)╯
//------------------------------api↓↓↓---------------------------------------//
//1、添加留言
export const addMsg = params => post('/msgBoard/addMsgBoard', params);

//2、获取模块展示排序
export const getFrist = params => get('/first-module/list', params);

//3、获取首页模块内容
export const getContext = params => get('/first-content/allContext', params);

//3、获取首页信息
export const getHomePage = params => get('/home-page', params);

//4、抬头获取分类
export const getClassifyTree = params => get('/classify/classifyTree', params);

//4、获取分类
export const getClassifyInfo = params => get('/classify/getById', params);

//5、通过id获取商品
export const getGoodsById = params => get('/goods/getGoodsById', params);

//6、根据分类获取商品list
export const getGoodsList = params => get('/goods/getByClassify', params);

//7、查询第一级下的分类
export const getOneClassifyFirst = params => get('/goods/getByClassifyFirst', params);

//8、根据id查询二级分类
export const getLowerClassify = params => get('/classify/getLowerClassify', params);

//9、根据标签id查询商品
export const getGoodsByLable = params => get('/goods/getGoodsByLabel', params);

//10、获取随机商品
export const getOthers = params => get('/goods/getGoodsByRands', params);

//6、根据分类获取商品分页
export const getGoodsPage = params => get('/goods/getByClassify/page', params);



// WEBPACK FOOTER //
// ./src/api/api.js